import { useEffect, useState, ReactNode } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

interface DashboardLinkProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

/**
 * A drop-in replacement for <Link to="/dashboard"> that redirects
 * unauthenticated users to /auth instead.
 */
export default function DashboardLink({ children, className, onClick }: DashboardLinkProps) {
  const navigate = useNavigate();
  const [authed, setAuthed] = useState<boolean | null>(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setAuthed(!!data.session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setAuthed(!!session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onClick?.();
    navigate(authed ? "/dashboard" : "/auth");
  };

  return (
    <a href="/dashboard" onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
